import { RECOMMENDED_JOBS, ALL_JOBS } from './JobsConstants';

export const getSelectedTab = (selectedTab, setSelectedJobsType) => {
    if (selectedTab === RECOMMENDED_JOBS) {
        setSelectedJobsType(RECOMMENDED_JOBS);
    } else if(selectedTab === ALL_JOBS) {
        setSelectedJobsType(ALL_JOBS);
    }
}
